<template>
  <div class="c-app">
    <div class="fix-header px-4">
      <div class="row m-0 p-0 form-inline w-100 h-100">
        <div class="col m-0 p-0">
          <div class="row form-inline">
            <div class="col fs-16 bolder"></div>
          </div>
          <div class="row fs-12" style="visibility: hidden">
            <div class="col-auto form-inline">
              <CIcon name="cil-phone" class="mr-1" />
              Call
            </div>
            <div class="col-auto form-inline">
              <CIcon name="cib-whatsapp" class="mr-1" />
              Whats app
            </div>
          </div>
        </div>
        <div
          class="col-auto m-0 p-0 form-inline fs-24"
          style="display: inline-flex; justify-content: right"
        >
          <img src="/ic_logo.png" alt="Seelfa" height="40" />
          Seelfa
        </div>
      </div>
    </div>
    <div class="scroll-block">
      <div class="row">
        <div class="col-3"></div>
        <div class="col-6">
          <div class="mt-3 fs-16 bold text-center">Transaction History</div>
          <div class="fs-12 text-center">
            ({{ timeConverter(fromDate) }} - {{ timeConverter(toDate) }})
          </div>
        </div>
        <div class="col-3 text-center" style="visibility: hidden">
          <img src="/translate-icon.svg" alt="" height="18" />
          <a class="d-block">English</a>
        </div>
      </div>
      <div class="summary-block">
        <div class="row">
          <div class="col-auto pr-1">
            <div class="summary-title">Total Debit(-)</div>
            <div class="summary-amount">
              {{ currencySymbol }}{{ amountSumGave }}
            </div>
          </div>
          <div class="col separater"></div>
          <div class="col-auto px-1">
            <div class="summary-title">Total Credit(+)</div>
            <div class="summary-amount">
              {{ currencySymbol }}{{ amountSumGot }}
            </div>
          </div>
          <div class="col separater"></div>
          <div class="col-auto pl-1">
            <div class="summary-title">Net Balance</div>
            <div class="summary-amount">
              <span
                :style="
                  'color:' +
                  (amountSumGave - amountSumGot > 0 ? 'red' : '#0f814d')
                "
              >
                {{ currencySymbol
                }}{{ Math.abs(amountSumGave - amountSumGot) }}</span
              >
              {{ amountSumGave - amountSumGot > 0 ? " Dr" : " Cr" }}
              <div class="fs-12">
                {{
                  this.amountSumGave > this.amountSumGot
                    ? "(Customer will give)"
                    : "(Customer will get)"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-block">
        <table class="table table-bordered" width="100%">
          <thead>
            <tr>
              <td>Date</td>
              <td>Debit(-)</td>
              <td>Credit(+)</td>
              <td>Balance</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(entry, index) in entries" :key="index">
              <td>
                <div style="color: red">{{ index == 0 ? "Latest" : "" }}</div>
                {{ timeConverter(entry.entryDate) }}
              </td>
              <td style="background-color: rgba(222, 24, 54, 0.05)">
                {{ entry.amountGave == 0 ? "" : entry.amountGave }}
              </td>
              <td style="background-color: rgba(15, 129, 77, 0.1)">
                {{ entry.amountGot == 0 ? "" : entry.amountGot }}
              </td>
              <td>
                <span
                  :style="'color:' + (entry.balance > 0 ? 'red' : '#0f814d')"
                  >{{ Math.abs(entry.balance) }}</span
                >

                {{ entry.balance > 0 ? " Dr" : " Cr" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
//import usersData from "./UsersData";
import axios from "axios";

export default {
  name: "Details",
  data() {
    return {
      businessN: "",
      customer: {},
      entries: [],
      amountSumGave: 0,
      amountSumGot: 0,
      fromDate: "",
      toDate: "",
      currencySymbol: "",
    };
  },

  created() {
    const customer_docid = this.$route.params.customer_docid;
    var api_url =
      "https://us-central1-seelfa-206f0.cloudfunctions.net/getEntriesOfCustomer";

    axios
      .get(api_url + "?cid=" + customer_docid)
      .then((response) => {
        this.currencySymbol = response.data.currencySymbol;
        this.toDate = response.data.toDate;
        this.fromDate = response.data.fromDate;
        this.amountSumGave = response.data.amountSumGave;
        this.amountSumGot = response.data.amountSumGot;
        this.entries = response.data.entries;
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  },
  methods: {
    timeConverter(UNIX_timestamp) {
      var a = new Date(UNIX_timestamp * 1000);
      var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      var year = a.getFullYear();
      var month = months[a.getMonth()];
      var date = a.getDate();
      var hour = a.getHours();
      var min = a.getMinutes();
      var sec = a.getSeconds();
      var time = date + " " + month + " " + year;
      return time;
    },
  },
};
</script>
<style scoped>
.col.separater {
  display: inline-flex;
  margin: 0 auto;
  padding: 0;
  max-width: 1px;
  background-color: rgba(144, 145, 146, 0.3);
}
.c-app {
  display: flex;
  margin: 0 auto;
  max-width: 480px;
  width: 100%;
}
.fix-header {
  display: flex;
  position: fixed;
  background-color: #4daf4e;
  width: 100%;
  max-width: 480px;
  height: 90px;
  color: white;
}
.scroll-block {
  margin: 90px auto 0 auto;
  position: fixed;
  width: 100%;
  max-width: 480px;
  height: calc(100vh - 92px);
  overflow-x: hidden;
  overflow-y: auto;
  background-color: white;
}
.summary-block {
  margin: 8px;
  padding: 8px 16px;
  border: solid 1px #909192;
  border-radius: 4px;
}
.summary-block .summary-title {
  font-size: 14px;
  color: #909192;
}
.summary-block .summary-amount {
  font-size: 15px;
  color: #2c2c2b;
}
.table-block {
  padding: 0 8px;
  font-size: 12.8px;
}
.table-block table thead tr {
  background-color: #f0f2f4;
  font-weight: bold;
}
.table-block table th,
.table-block table td {
  padding: 8px;
}
.fs-24 {
  font-size: 24px;
}
.fs-16 {
  font-size: 16px;
}
.fs-12 {
  font-size: 12px;
}
.bold {
  font-weight: bold;
}
.bolder {
  font-weight: bolder;
}
</style>
